<template>
  <div id="tzzjy">
    <header class="am-topbar">
      <OffCanvas class="meun">边侧栏</OffCanvas>
      <div class="logo-wrapper">
        <div class="title">投资者教育</div>
      </div>
    </header>
    <div class="tab">
      <router-link v-for="(item,key,index) in title" :to="{ name: 'tzzjy', params: { nr: key }}"
                   v-if="Math.floor(index/4)===0&&Math.floor(ChoseTab/4)===0"
                   :key="key">{{item}}
      </router-link>
      <router-link v-for="(item,key,index) in title" :to="{ name: 'tzzjy', params: { nr: key }}"
                   v-if="Math.floor(index/4)===1&&Math.floor(ChoseTab/4)===1"
                   :key="key">{{item}}
      </router-link>
      <router-link v-for="(item,key,index) in title" :to="{ name: 'tzzjy', params: { nr: key }}"
                   v-if="Math.floor(index/4)===2&&Math.floor(ChoseTab/4)===2"
                   :key="key">{{item}}
      </router-link>
      <span class="icon" @click="showOthers=true" v-show="!showOthers"><i class="am-icon-chevron-down"></i></span>
      <span class="icon" @click="showOthers=false" v-show="showOthers"><i class="am-icon-chevron-up"></i></span>
    </div>
    <div class="tab" v-show="showOthers">
      <router-link v-for="(item,key,index) in title" :to="{ name: 'tzzjy', params: { nr: key }}"
                   v-if="Math.floor(index/4)===1&&Math.floor(ChoseTab/4)!==1"
                   :key="key">{{item}}
      </router-link>
      <router-link v-for="(item,key,index) in title" :to="{ name: 'tzzjy', params: { nr: key }}"
                   v-if="Math.floor(index/4)===0&&Math.floor(ChoseTab/4)===1"
                   :key="key">{{item}}
      </router-link>
    </div>
    <div class="tab" v-show="showOthers">
      <router-link v-for="(item,key,index) in title" :to="{ name: 'tzzjy', params: { nr: key }}"
                   v-if="Math.floor(index/4)===2&&Math.floor(ChoseTab/4)!==2"
                   :key="key">{{item}}
      </router-link>
      <router-link v-for="(item,key,index) in title" :to="{ name: 'tzzjy', params: { nr: key }}"
                   v-if="Math.floor(index/4)===0&&Math.floor(ChoseTab/4)===2"
                   :key="key">{{item}}
      </router-link>
    </div>
    <List :list="list" :name="$route.params.nr" class="min-height"></List>
    <ICP></ICP>
  </div>
</template>

<script>
  import OffCanvas from '@/components/OffCanvas/OffCanvas'
  import ICP from '@/components/ICP/ICP'
  import List from '@/components/list/List'

  import ajax from '@/common/ajax/ajax'
  import title from '@/common/title/title'

  export default {
    name: 'tzzjy',
    data () {
      return {
        title: title.tzzjytitle,
        list: [],
        showOthers: false
      }
    },
    created: function () {
      ajax.getTzzjy(this.$route.params.nr).then(
        data => {
          this.list = data
        }
      )
    },
    components: {
      OffCanvas,
      ICP,
      List
    },
    watch: {
      $route: function () {
        ajax.getTzzjy(this.$route.params.nr).then(
          data => {
            this.list = data
          }
        )
      }
    },
    computed: {
      ChoseTab: function () {
        let i = 0
        for (let item in this.title) {
          if (this.$route.params.nr === item) {
            this.showOthers = false
            return i
          }
          i++
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  #tzzjy
    .tab
      padding 0 $bj 0 $bj
      background-color $color2
      font-size $font_size2
      color $font_color3
      height 40px
      line-height 40px
      .icon
        margin-left -2px
        height 24px
        width 24px
      a
        margin 0 15px 0 0
        &:after
          content ' '
          width 0
          height 5px
          left 50%
          top 23px
          position absolute
        &.router-link-active
          color $font_color2
          position relative
          &:after
            background-color $color1
            width 100%
            left 0
            transition left, width 0.5s, 0.5s

</style>



// WEBPACK FOOTER //
// tzzjy.vue?9a45322c